module.exports = __webpack_public_path__ + "img/hy_kclb.f9d20bd6.svg";